module.exports = __webpack_public_path__ + "img/qilin-stage4-sulking.9748ae12.png";